module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG0002-04708508898a5f1e4c5a1fef01849bc7.png";